import { actions, types } from './requests'
export const GETFROMIDSUBID_TYPES = {
    ...types('GETFROMIDSUBID'),
}
export const GETFROMIDSUBID_ACTIONS = {
    ...actions('GETFROMIDSUBID'),
}
